import { Link } from 'react-router-dom';
import { categories, siteName } from '@/mocks/articles';

export default function Footer() {
  const year = 2026;
  return (
    <footer className="border-t-2 border-primary-500/70 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-foreground-900">{siteName}</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-6 text-foreground-600">
              专注数码圈一手爆料，第一时间汇总手机参数曝光、未发布产品图、配置价格预测与厂商内部消息。
            </p>
            <div className="mt-4 flex items-center gap-2 text-foreground-500">
              <i className="ri-megaphone-line" aria-hidden="true" />
              <span className="text-xs font-medium">比媒体更早，看到新机真容</span>
            </div>
          </div>

          {/* 栏目 */}
          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900">栏目分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/news?cat=${c.slug}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 站点 */}
          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900">浏览站点</h4>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">首页</Link></li>
              <li><Link to="/news" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">最新爆料</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">关于我们</Link></li>
              <li><Link to="/faq" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">常见问题</Link></li>
            </ul>
          </div>

          {/* 联系订阅 */}
          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900">保持联系</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-600" aria-hidden="true" />
                <a href="mailto:hello@meiri-xinliao.example" className="transition-colors hover:text-primary-700" rel="nofollow">
                  hello@meiri-xinliao.example
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-rss-line text-accent-600" aria-hidden="true" />
                每日更新，第一时间同步
              </li>
            </ul>
            <Link
              to="/about#contact"
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-900 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
            >
              <i className="ri-mail-send-line" aria-hidden="true" />
              与我们联系
            </Link>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteName} · 数码圈一手爆料内容平台 · 部分内容标注「疑似/据传」，请理性参考</p>
          <p className="flex items-center gap-4">
            <Link to="/about" className="hover:text-primary-700">关于我们</Link>
            <Link to="/faq" className="hover:text-primary-700">常见问题</Link>
            <Link to="/about#contact" className="hover:text-primary-700">联系我们</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}